import {UiTheme, UiThemeSize} from "@view/theme/types";

export const buildClassNamesThemes = ({
                                          theme,
                                          themeSize,
                                      }: {
    theme: UiTheme,
    themeSize: UiThemeSize
}) => {

    return `${theme === 'dark' ? 'darkTheme' : 'lightTheme'} ${themeSize === 'large' ? 'largeSizeTheme' : 'smallSizeTheme'}`

}